import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 15, viewBox: "0 0 13 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 1.5V13.5M12 7.5H0", stroke: "#0058DD", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgAdd;
